module.exports = __webpack_public_path__ + "static/media/aider_welcome_g.0e208396.gif";